import styled from 'styled-components';

export const NoOfItems = styled.div`
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
`;
